import { render, staticRenderFns } from "./view-category.vue?vue&type=template&id=597874c5&scoped=true&"
import script from "./view-category.vue?vue&type=script&lang=js&"
export * from "./view-category.vue?vue&type=script&lang=js&"
import style0 from "./view-category.vue?vue&type=style&index=0&id=597874c5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "597874c5",
  null
  
)

export default component.exports